// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-review-clm {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 40px;
}
.channel-clm {
	width: 120px;
}
.question-clm {
	width: 360px;
}
.userid-clm {
	width: 240px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/guardrail/content-review/index.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;AAClB;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb","sourcesContent":[".content-review-clm {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tline-height: 40px;\n}\n.channel-clm {\n\twidth: 120px;\n}\n.question-clm {\n\twidth: 360px;\n}\n.userid-clm {\n\twidth: 240px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
